export default __webpack_public_path__ + "static/media/login-reset.18797ac4.png";